export const prompt = {
    noData: 'Keine Ergebnisse',
};
